import {$http} from '@/utils/https'
import {
    CHANGE_LOADING_PRODUCTS,
    CHANGE_LOADING_LIST,
    SET_LIST,
    SEARCH_RESULT,
    GET_CATEGORY,
    GET_CATEGORY_LOADING
} from '../mutation-types';
import {
    GET_LIST,
    GET_LIST_CATEGORY,
    SEARCH
} from '../action-types';


const state = {
    list: null,
    listLoading: false,
    productList: null,
    productsLoading: false,
    search: '',
    categoryLoading: false
};

const getters = {
    list: state => state.list,
    products: state => state.productList,
    searchResult: state => state.search,
    categoryLoading: state => state.categoryLoading
};

const actions = {
    [GET_LIST]: async ({commit}) => {
        try {
            commit(GET_CATEGORY_LOADING, false);
            const response = await $http.get(`v1/categories?include=sellers`);
            commit(SET_LIST, response.data?.data);
            commit(GET_CATEGORY_LOADING, true);
        } catch (e) {
            commit(GET_CATEGORY_LOADING, true);
            throw e;
        }
    },

    [GET_LIST_CATEGORY]: async ({ commit, state }, payload) => {
        if (payload.skip === 0) {
            commit(GET_CATEGORY, null);
        }

        // Ensure category parameter is preserved from route query when filters are applied
        const categoryParam = payload.category || '';

        const response = await $http.get(
            `v1/products?orderField=${payload.orderField || ''}&orderBy=${payload.orderBy || ''}&category=${categoryParam}&seller=${payload.seller || ''}&search=${payload.search || state.search || ''}&skip=${payload.skip || 0}&limit=${payload.limit || 20}`
        );

        if (state.productList?.products && payload.skip > 0) {
            state.productList.products = [...state.productList.products, ...response.data?.data?.products];
        } else {
            commit(GET_CATEGORY, response.data?.data);
        }
    },

    [SEARCH]: async ({commit}, payload) => {
        const response = await $http.get(`v1/products?search=${payload}`);
        commit(SEARCH_RESULT, response.data?.data);
    }
};

const mutations = {
    [GET_CATEGORY_LOADING](state, status) {
        state.categoryLoading = status
    },
    [SEARCH_RESULT](state, list) {
        state.search = list
    },
    [SET_LIST](state, list) {
        state.list = list;
    },
    [CHANGE_LOADING_LIST](state, status) {
        state.listLoading = status;
    },
    [CHANGE_LOADING_PRODUCTS](state, status) {
        state.productsLoading = status;
    },
    [GET_CATEGORY](state, list) {
        state.productList = list
    }

};
export default {
    state,
    getters,
    actions,
    mutations,
};
